import { render, staticRenderFns } from "./DateSpan.vue?vue&type=template&id=17666137"
import script from "./DateSpan.vue?vue&type=script&lang=js"
export * from "./DateSpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports